export const messageBox = "m1gi3f9e";
export const moreButtonContainer = "m141tss1";

require("./style.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");